// extracted by mini-css-extract-plugin
export default {"wrapper":"Onbording_wrapper__8NhPN","stepsCount":"Onbording_stepsCount__40Bm4","step":"Onbording_step__nbTI5","active":"Onbording_active__32wt2"};